<template>
  <div class="ReportDetails">

    <Head :lanshow="ActiveName"
          :title="$tc('header.back')" />
    <!-- <NavBar /> -->
    <h5 class="mianbaoxie">
      <span>当前位置：</span><span>首页 </span><span> > {{ report_type }} </span><span>> 举报页面 </span>
    </h5>
    <!-- 举报 -->
    <div class="content"
         v-if="isShow">
      <van-tabs v-model="activeName"
                type="card">
        <van-tab title="注册举报"
                 name="a">
          <ReportRegister @tojubaoChangestate="jubaoChangestate"
                          :ReportTypeId="$route.params.id"
                          :IsFailRegister="isEchoRegister" />
        </van-tab>
        <van-tab title="实名举报"
                 name="b">
          <RealNameReport @tojubaoChangestate="jubaoChangestate"
                          :ReportTypeId="$route.params.id"
                          :IsFailRealName="isEchoRealName" />
        </van-tab>
        <van-tab title="匿名举报"
                 name="c"
                 v-if="id != 7 && id != 644">
          <ReportAnonymous @tojubaoChangestate="jubaoChangestate"
                           :ReportTypeId="$route.params.id"
                           :IsFailEchoAnonymous="isEchoAnonymous" />
        </van-tab>
      </van-tabs>
    </div>
    <!-- 举报失败 -->
    <div class="content"
         v-if="isShibai">
      <div class="content-shibai">
        <div>
          <img src="@/assets/img/举报失败.png"
               alt=""
               style="width: 30vw" />
        </div>
        <div style="margin: 5vw 0vw; font-weight: 700">举报失败</div>
        <div class="content-shibai-bth">
          <van-button type="info"
                      plain
                      style="width: 84vw"
                      @click="retry(kind)">重试</van-button>
          <!-- loading30秒 -->
          <!-- <div>{{time}}举报中。。。</div> -->
        </div>
      </div>
    </div>
    <!-- 举报成功 -->
    <div class="content"
         v-if="isSuccess">
      <div class="content-success">
        <div class="success-img">
          <img src="@/assets/img/jubaochenggong.png"
               alt=""
               style="width: 22.4vw" />
        </div>
        <div style="margin: 5vw 0vw"
             class="success-neirong">
          <p style="font-weight: 700;font-size:4.26vw">您的举报信息已提交成功，感谢您的举报！</p>
          <div style="margin-top: 2vw; font-weight: 700;font-size:4.26vw">
            查询码{{ chaxunma }}
          </div>
          <div class="fuzhi">
            <van-button class="tag-read"
                        :data-clipboard-text="chaxunma"
                        @click="copy"
                        plain
                        style="height: 8vw;font-size:3.73vw;color:#002FA7">复制</van-button>
          </div>
        </div>
        <div class="success-shuoming">
          <p>说明：</p>
          （1） 复制此页面链接，重新再浏览器中打开，该查询码将不再复现；
          <br />（2） 关闭此页面，该查询码将不再复现。
        </div>
        <div class="content-success-bth">
          <van-button type="info"
                      plain
                      style="width: 84vw"
                      @click="gojubao">继续举报</van-button>
        </div>
      </div>
    </div>
    <Footer />
  </div>
</template>

<script>
import { mapMutations, mapState } from 'vuex'
import RealNameReport from './components/RealNameReport.vue'
import ReportRegister from './components/ReportRegister.vue'
import ReportAnonymous from './components/ReportAnonymous.vue'
import Clipboard from 'clipboard'
const stringRandom = require('string-random')

export default {
  name: '',
  props: {},
  data () {
    return {
      time: 30,
      activeName: 'b',
      chaxunma: 'X322022809290188',
      isShow: true,
      isShibai: false,
      isSuccess: false,
      isEchoRegister: false,
      isEchoRealName: false,
      isEchoAnonymous: false,
      report_type: '',
      type: '',
      kind: '',
      id:''
    }
  },
  created () {
    this.setShowLoading(false)
    this.id=this.$route.params.id
    this.reportType(this.$route.params.id)
    // 用户是否登录
    const token =
      localStorage.getItem('userInfo') &&
      JSON.parse(localStorage.getItem('userInfo')) &&
      JSON.parse(localStorage.getItem('userInfo')).token
    if (token) {
      // 显示登陆头像
      this.setActiveName(true)
      this.activeName = "a"
    } else {
      this.setActiveName(false)
      this.activeName = "b"
    }
    if (!localStorage.getItem('visitorHeader')) {
      localStorage.setItem('visitorHeader', new Date().getTime() + stringRandom(8, true))
    }
  },
  methods: {
    ...mapMutations(['setShowLoading', 'setActiveName']),
    retry (kind) {
      this.$toast.loading({
        message: '加载中...',
        forbidClick: true
      })
      if (kind == 0) {
        this.$CookieApi
          .reportAddReport(JSON.parse(localStorage.getItem('reportForm')), '', { noToast: false }).then(res => {
            if (res) {
              this.state = true
              this.chaxunma = res
              location.reload()
            } else {
              this.isShow = true
              this.isSuccess = false
              this.isShibai = false
              this.isEchoRegister = true
            }
            this.$toast.clear()
          }).catch(() => {
            this.isShow = true
            this.isSuccess = false
            this.isShibai = false
            this.isEchoRegister = true// 失败把数据回显到页面   传个状态给过去，判断是否为举报失败的 true为失败

            this.$toast.clear()
          })
      } else if (kind == 1) {
        this.$CookieApi
          .reportAddReport(JSON.parse(localStorage.getItem('reportForm')), localStorage.getItem('visitorHeader'), { noToast: false }).then(res => {
            if (res) {
              this.state = true
              this.chaxunma = res
              location.reload()
            } else {
              this.isShow = true
              this.isSuccess = false
              this.isShibai = false
              this.isEchoRealName = true
            }
            this.$toast.clear()
          }).catch(() => {
            this.isShow = true
            this.isSuccess = false
            this.isShibai = false
            this.isEchoRealName = true// 失败把数据回显到页面
            this.$toast.clear()
          })
      } else if (kind == 2) {
        this.$CookieApi
          .reportAddReport(JSON.parse(localStorage.getItem('reportForm')), localStorage.getItem('visitorHeader'), { noToast: false }).then(res => {
            if (res) {
              this.state = true
              this.chaxunma = res
              location.reload()
            } else {
              this.isShow = true
              this.isSuccess = false
              this.isShibai = false
              this.isEchoAnonymous = true
            }
            this.$toast.clear()
          }).catch(() => {
            this.isShow = true
            this.isSuccess = false
            this.isShibai = false
            this.isEchoAnonymous = true// 失败把数据回显到页面
            this.$toast.clear()
          })
      }
    },
    // 判断举报类型
    reportType (id) {
      if (id == 1) {
        this.report_type = '政治类'
      } else if (id == 2) {
        this.report_type = '暴恐类'
      } else if (id == 3) {
        this.report_type = '诈骗类'
      } else if (id == 4) {
        this.report_type = '色情类'
      } else if (id == 5) {
        this.report_type = '低俗类'
      } else if (id == 6) {
        this.report_type = '赌博类'
      } else if (id == 7) {
        this.report_type = '侵权类'
      } else if (id == 8) {
        this.report_type = '谣言类'
      }
    },
    copy () {
      var clipboard = new Clipboard('.tag-read')
      clipboard.on('success', (e) => {
        this.$toast('复制成功')
        // 释放内存
        clipboard.destroy()
      })
      clipboard.on('error', (e) => {
        // 不支持复制
        this.$toast('该浏览器不支持自动复制')

        // 释放内存
        clipboard.destroy()
      })
    },
    gojubao () {
      this.isShow = true
      this.isSuccess = false
      this.isShibai = false
    },
    jubaoChangestate ({ state, data, type, kind }) {
      this.isSuccess = state
      this.isShibai = !state
      this.isShow = false
      this.chaxunma = data
      this.type = type
      this.kind = kind
    }
  },
  computed: {
    ...mapState(['ActiveName'])
  },
  watch: {
    // ActiveName: {
    //   immediate: true,
    //   handler () {
    //     // 用户是否登录
    //     const token =
    //       localStorage.getItem('userInfo') &&
    //       JSON.parse(localStorage.getItem('userInfo')) &&
    //       JSON.parse(localStorage.getItem('userInfo')).token
    //     if (token) {
    //       // 显示登陆头像
    //       this.setActiveName(true)
    //     } else {
    //       this.setActiveName(false)
    //     }
    //   }
    // }
  },
  components: { RealNameReport, ReportRegister, ReportAnonymous }
}
</script>

<style lang="scss" scoped>
.ReportDetails {
  margin-top: 10.47vw;
  h5 {
    background-color: #f6f8fa;
  }
  .content {
    padding: 4vw 4vw 0 4vw;
  }
  ::v-deep .van-field__control {
    border: 0;
    border-radius: inherit;
  }
}
.content-shibai {
  // display: flex;
  // justify-content: center;
  // align-items: center;
  box-sizing: border-box;
  padding: 4vw;
  font-size: 4vw;

  div {
    // margin: 0 auto;
    text-align: center;
  }
}
.content-shibai-bth {
  margin-bottom: 10vw;
}
.content-success {
  box-sizing: border-box;
  font-size: 4vw;
  padding: 4vw;
  .success-img {
    text-align: center;
  }
  .success-neirong {
    text-align: center;
  }
  .content-success-bth {
    margin-bottom: 10vw;
    margin-top: 5vw;
    text-align: center;
  }
}
.success-shuoming {
  font-size: 3.73vw;
  font-family: MicrosoftYaHei;
  color: #666666;
}
</style>
